import React, { useRef, useState, 
    // useEffect
 } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { formatMoneda, 
    // formatoMonto, validaMonto, 
    validaSoloNumero } from '../../util/varios';
import { Mensaje, 
    // MensajeSiNo 
} from '../mensajes2';
import moment from 'moment';
import { Dimmer } from '../spinner';

import CatalogoOrdenesdeCompraDevolver from '../../catalogos/catalogoOrdenesdeCompraDevolver';
// import ModalAgregarEgresoEnviar from './agregarEgresoEnviarDespacho';
import ModalAgregarEgresoEnviarCatalogo from './agregarEgresoCatalogo';

export const AgregarChequeAprovado = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    // const idusuario = JSON.parse(localStorage.getItem('idusuario'));
    // const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [values, setValues] = useState()
    const [operacion, setOperacion] = useState(0);
    const [mostrar4, setMostrar4] = useState(false);
    // const [val, setVal] = useState(0);
    const [val2, setVal2] = useState(0);
    const [activo, setActivo] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    // const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtId = useRef();
    const txtIdCom = useRef();
    const txtRazon = useRef();
    const txtIdprov = useRef();
    const txtFecha = useRef();
    const txtUbi = useRef();
    const txtDescriclas = useRef();
    const txtMonto = useRef();
    const txtBanco = useRef();
    // const txtFechacrea = useRef();
    const txtTipo = useRef();
    const txtMotivo = useRef();
    const txtIdordenpago = useRef();


    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        setActivate(false);
        setActivo(true);
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        props.onHideRenderizar();
        props.onHideCancelar();
        blanquear();
    }

    const catalogoClass = (e) => {
        e.preventDefault();
        setMostrar4(true);
    };

    const handleInputNumChange = (event) => {
        event.preventDefault();
        validaSoloNumero(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const handleAceptaOrdenesCompras = (value) => {
        setMostrar4(false);
        setValues(value)
        txtId.current.value = value.idchequeemitido;
        txtDescriclas.current.value = value.numerocheque;
        txtBanco.current.value = value.nombre;
        txtMonto.current.value = formatMoneda(value.montocheque.toString().replace(',', '').replace('.', ','), ',', '.', 2)
        setActivo(false)
    }

    const handleCancelaras = () => {
        setMostrar4(false);
    }

    const seleccionarOrdenesCompras = (id) => {

        let endpoint = `${op.conexion}/api/administracion/registrosordencompracatid?id=${id}&idefiscal=${idefiscal}`;
        console.log(endpoint)
        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status === 200) {

                if (response.data.idordenpago > 0) {
                    setActivate(false);
                    txtId.current.value = response.data.numordenpago;
                    txtDescriclas.current.value = response.data.concepto.trim();
                    txtIdCom.current.value = response.data.idcompromiso;
                    txtRazon.current.value = response.data.razonsocial.trim();
                    txtIdprov.current.value = response.data.idproveedor;
                    txtFecha.current.value = moment.utc(response.data.fecha).format('DD-MM-YYYY');
                    txtUbi.current.value = response.data.ubicacion;
                    txtIdordenpago.current.value = response.data.idordenpago;
                    txtTipo.current.value = response.data.tipo;
                    setActivo(false);
                } else {
                    txtId.current.value = '';
                    txtDescriclas.current.value = '';
                    txtIdCom.current.value = '';
                    txtRazon.current.value = '';
                    txtIdprov.current.value = '';
                    txtFecha.current.value = '';
                    txtUbi.current.value = '';
                    txtIdordenpago.current.value = '';
                    txtTipo.current.value = '';
                    setActivo(true);
                }
            }
        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        }).finally(function () {
            setActivate(false);
        });
    }
    const handleSolicitudes = (event) => {
        event.preventDefault();
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                seleccionarOrdenesCompras(event.target.value);
            }
        }
    };

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;

        if (txtId.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Debe seleccioanr un Egreso !', icono: 'informacion' });
            sigue = false;
            txtId.current.focus();
        }
        else if (txtMotivo.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ El Motivo no debe ir Vacio !', icono: 'informacion' });
            sigue = false;
            txtMotivo.current.focus();
        }
        else if (sigue) {
            seleccionarSolicitudesCompras();
        }

    };
    const seleccionarSolicitudesCompras = () => {
        blanquear();
        var datos = {
            motivo: txtMotivo.current.value.trim(),
            numerocheque:values.numerocheque,
            banco:values.nombre,
            fechaemi:values.fechaemi,
            idchequeemitido:values.idchequeemitido,
            montocheque:values.montocheque,
            portador:values.portador
        };
        props.onHideAceptaCatalogo(datos);
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOperacion(props.operacion);
                if (props.operacion === 1) {
                    setVal2(1);
                } else {
                    txtId.current.value = '';
                    txtDescriclas.current.value = '';
                    txtIdCom.current.value = '';
                    txtRazon.current.value = '';
                    txtIdprov.current.value = '';
                    txtFecha.current.value = '';
                    txtUbi.current.value = '';
                    txtIdordenpago.current.value = '';;
                    txtTipo.current.value = '';
                    txtMotivo.current.value = '';
                }
            }}>
            <Modal.Header className='header-azulGradiant'>
                <h3>
                    Incluir Documento
                </h3>
                <a type='button' 
                    onClick={cancelar}>
                    salir<i className="fa fa-times"></i>
                </a>
            </Modal.Header>
            <Modal.Body>
                <CatalogoOrdenesdeCompraDevolver
                    onHideCancelar={handleCancelaras}/>
                <ModalAgregarEgresoEnviarCatalogo
                    show={mostrar4}
                    onHideCancela={handleCancelaras}
                    onHideAceptaCatalogo={handleAceptaOrdenesCompras}/>
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div style={{height:'300px'}} className='overflow-auto'>
                    <input type='hidden' ref={txtIdCom} />
                    <input type='hidden' ref={txtIdordenpago} />
                    <input type='hidden' ref={txtRazon} />
                    <input type='hidden' ref={txtIdprov} />
                    <input type='hidden' ref={txtFecha} />
                    <input type='hidden' ref={txtUbi} />
                    <input type='hidden' ref={txtTipo} />
                    <fieldset className="col-12 border-azul rounded m-0 p-2">
                        <legend className="float-none m-0 fw-bold w-auto">
                            Incluir Documento
                        </legend>
                        <div className='col-12 m-0 p-0 d-flex flex-wrap'>
                            <div className='col-12 p-0 m-0 mb-2'>
                                <div className='input-group input-group-sm col-3 m-0 mr-auto p-0'>
                                    <label className="input-group-text" >
                                        Código:
                                    </label>
                                    <input type="text" 
                                        name='codigo' 
                                        ref={txtId} 
                                        onKeyUp={handleSolicitudes} 
                                        onBlur={handleInputNumChange} 
                                        className="form-control bg-light" 
                                        id="inputLogin" />
                                    <button disabled={operacion === 4 || operacion === 2 ? true : deshabilitado} 
                                        onClick={catalogoClass} className="btn btn-sm  btn-light border shadow-none" >
                                        <i className="fa fa-search"></i> 
                                    </button>
                                </div>
                            </div>
                            <div className='input-group input-group-sm col-4 m-0 p-0 pr-2'>
                                <label className="input-group-text" >
                                    N° Cheque:
                                </label>
                                <input type="text" 
                                    className="form-control text-uppercase bg-light" 
                                    disabled={true} 
                                    ref={txtDescriclas}  
                                    id="inputDireccion" />
                            </div>
                            <div className='input-group input-group-sm col-4 p-0 m-0'>
                                <label className="input-group-text" >
                                    Banco:
                                </label>
                                <input type="text" 
                                    className="form-control text-uppercase bg-light" 
                                    disabled={true} 
                                    ref={txtBanco}  
                                    id="inputDireccion" />
                            </div>
                            <div className='input-group input-group-sm col-4 p-0 pl-2 m-0'>
                                <label className="input-group-text" >
                                    Monto:
                                </label>
                                <input type="text" 
                                    className="form-control text-uppercase text-right bg-light" 
                                    disabled={true} 
                                    ref={txtMonto}  
                                    id="inputDireccion" />
                            </div>
                            <div className='col-12 input-group input-group-sm p-0 m-0 mt-2'>
                                <label className="input-group-text" >
                                    Motivo:
                                </label>
                                <textarea type="text" 
                                    className="form-control text-uppercase" 
                                    style={{ height: '60px' }} 
                                    ref={txtMotivo} 
                                    placeholder="Describa el Motivo" 
                                    id="inputDireccion" />
                            </div>
                        </div>
                    </fieldset>
                </div>
            </Modal.Body>
            <Modal.Footer className='footer-azulGradiant'>
                <button type="button" 
                    ref={btnAcepta} 
                    onClick={onChangeValidar} 
                    disabled={activo} 
                    className="btn btn-sm rounded btnPrimary-azulGradiant">
                    <i className="far fa-check-circle"></i> Aceptar
                </button>
                <button type="button" 
                    ref={btnCancela} 
                    onClick={cancelar} 
                    className="btn btn-sm rounded btnSecondary-azulGradiant">
                    <i className="fas fa-window-close"></i> Cancelar
                </button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />

        </Modal>

    );
}